module.exports = __webpack_public_path__ + "static/media/login-bg.9126d78f.jpg";